export default "__VITE_ASSET__46a1ef65__"